module.exports = __webpack_public_path__ + "img/17.65aa756f.webp";